import { InputAdornment, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

const NumberField = ({
  maxLength = Infinity,
  value,
  dispatch,
  handleBlur,
  action = "UPDATE_PROPERTY",
  label,
  property,
  dollars = false,
  lbs = false,
  ft = false,
  inches = false,
  payload,
  customClass = "",
  bold = false,
  width = "100px",
  variant = 'standard',
  showColor = false,
  disabled = false,
  integerOnly = true,
  id="",
}) => {

  let style = bold ? { fontWeight: "bold", width: width, textAlign: 'center' } : { width: width, textAlign: 'center' }
  if (showColor) {
    style = { ...style, color: value > 0 ? 'red' : 'green' }
  }

  const handleInputChange = (event) => {
    const newValue = event.target.value.replace(/,/g, ''); // remove commas
    if (newValue === '' || (newValue.length <= maxLength && !isNaN(newValue) && (integerOnly && !newValue.includes('.')))) {
      if (payload) {
        return dispatch({ type: action, payload: { ...payload, value: newValue } });
      }
      if (!property) {
        return dispatch({ type: action, payload: newValue });
      } else {
        return dispatch({ type: action, payload: { property, value: newValue } });
      }
    }
  };
  const formattedValue = (value ?? "").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // format with commas

  return (
    <TextField
      id={id}
      margin='dense'
      type="text"
      label={label}
      value={formattedValue}
      onChange={handleInputChange}
      onBlur={(e) => handleBlur(+e.target.value.replace(/,/g, ''), action, { property: property })} // remove commas before converting to integer
      disabled={disabled}
      onFocus={(event) => event.target.select()}
      InputLabelProps={{ shrink: true }}
      variant={variant}
      className={customClass}
      inputProps={{
        style,
        "aria-label": label,
      }}
      InputProps={
        dollars
          ? { startAdornment: <InputAdornment position="start">$</InputAdornment>, }
          : lbs
            ? { endAdornment: <InputAdornment position="end">lbs</InputAdornment>, }
            : ft
              ? { endAdornment: <InputAdornment position="end">ft</InputAdornment>, }
              : inches
                ? { endAdornment: <InputAdornment position="end">in</InputAdornment>, }
                : {}}
    />
  );
};

export default NumberField;



NumberField.propTypes = {
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};


